import '.d{display:flex;}.ssr-plugin'
import '.ai{justify-content:center;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ae{aspect-ratio:1/1;}.ssr-plugin'
import '.ay{border:none;}.ssr-plugin'
import '.az{background:var(--gray-100);}.ssr-plugin'
import '.a5{font-weight:400;}.ssr-plugin'
import '.af{flex-shrink:0;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

export interface CloseButtonProps {
  size?: Size
  onClick: () => void
  style?: Style
}

type Size = 'small' | 'medium' | 'large'
const sizeStyle: Record<Size, Style> = {
  large: {
    height: '2.5rem',
    width: '2.5rem',
    padding: '0.3125rem 0.375rem 0.375rem 0.3125rem',
    borderRadius: '0.625rem',
    fontSize: '1.5rem',
  },
  medium: {
    height: '2rem',
    width: '2rem',
    borderRadius: '0.5rem',
    fontSize: '1.4375rem',
  },
  small: {
    height: '1.5rem',
    width: '1.5rem',
    borderRadius: '0.375rem',
    fontSize: '1.125rem',
  },
}

export const CloseButton = ({
  size = 'large',
  onClick,
  style,
}: CloseButtonProps) => {
  return (
    <styled.button className="d ai t ae ay az a5 af a1"
      onClick={onClick}
      style={{
        ...sizeStyle[size],
        ...style,
      }}
    >
      {<FontAwesomeIcon icon={faXmark} />}
    </styled.button>
  )
}
